// Ordinary HTTPS anchors let the browser handle navigation on every device.
export const reviewsWebUrl = "https://www.google.com/maps/search/?api=1&query=Serce+Finansów+Paweł+Kowalewski+Suwałki";
const business = "Serce Finansów Paweł Kowalewski, Aleksandry Piłsudskiej 11, Suwałki";
export const directionsWebUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(business)}&travelmode=driving`;
export const googleLinkForDevice = (url) => url;
const currentAgent = () => typeof navigator === "undefined" ? "" : navigator.userAgent;
export const googleNavigationProps = (url, agent = currentAgent()) => ({
  href: url,
  target: /Android|iPhone|iPad|iPod/i.test(agent) ? "_self" : "_blank",
  rel: "noopener noreferrer",
});
export const reviewsUrl = reviewsWebUrl;
export const directionsUrl = directionsWebUrl;
export const googleNavigationTarget = "_blank";
